import { Badge, Flex } from "@chakra-ui/react";
import { CONVENIO_OPTIONS } from "./constants";

export function ConvenioBadge({ convenio }: { convenio?: string }) {
  if (!convenio) return null;
  const values = convenio
    .split(",")
    .map((s) => s.trim())
    .filter(Boolean);
  return (
    <Flex gap="4px" flexWrap="wrap">
      {values.map((v) => {
        const opt = CONVENIO_OPTIONS.find((c) => c.value === v);
        return (
          <Badge
            key={v}
            px="8px"
            py="2px"
            borderRadius="10px"
            fontSize="11px"
            fontWeight="700"
            bg="transparent"
            border="1.5px solid"
            borderColor={opt?.color ?? "#CBD5E0"}
            color={opt?.color ?? "#718096"}
          >
            {v}
          </Badge>
        );
      })}
    </Flex>
  );
}
